(() => {
  const config = JSON.parse(document.getElementById('rhsb-shopping-config').textContent);
  const root = config.root.replace(/\/$/, '') + '/';
  document.querySelectorAll('.rhsb-product-form, .shop-product-card__form').forEach(form => {
    const quantity = form.querySelector('[name="quantity"]');
    const steps = form.querySelectorAll('[data-quantity-step]');
    const checkout = form.querySelector('[data-direct-checkout]');
    const variant = form.querySelector('[name="id"]');
    const sku = form.querySelector('[data-current-sku]');
    let busy = false;
    let status = form.querySelector('.rhsb-cart-status');
    if (!status) {
      status = document.createElement('p');
      status.className = 'rhsb-cart-status';
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      form.append(status);
    }
    const updateQuantity = () => {
      const min = Number(quantity.min) || 1;
      steps.forEach(button => {
        button.disabled = busy || (button.dataset.quantityStep === '-1' && Number(quantity.value) <= min);
      });
    };
    steps.forEach(button => button.addEventListener('click', () => {
      if (button.dataset.quantityStep === '1') quantity.stepUp(); else quantity.stepDown();
      quantity.dispatchEvent(new Event('change', {bubbles:true}));
    }));
    if (quantity) {
      quantity.addEventListener('change', () => {
        if (!quantity.value || Number(quantity.value) < Number(quantity.min)) quantity.value = quantity.min || '1';
        updateQuantity();
      });
      updateQuantity();
    }
    const photos = form.querySelector('.rhsb-variations');
    if (photos && variant) {
      photos.hidden = false;
      variant.hidden = true;
      const fallbackLabel = form.querySelector('[data-variant-fallback-label]');
      if (fallbackLabel) fallbackLabel.hidden = true;
      photos.querySelectorAll('[data-variant-id]').forEach(button => {
        button.addEventListener('click', () => {
          if (busy || button.disabled) return;
          variant.value = button.dataset.variantId;
          variant.dispatchEvent(new Event('change', {bubbles:true}));
        });
      });
    }
    variant?.addEventListener('change', () => {
      photos?.querySelectorAll('[data-variant-id]').forEach(button => {
        button.setAttribute('aria-pressed', String(button.dataset.variantId === variant.value));
      });
      const image = document.querySelector('.product-gallery .gallery-image img');
      const imageUrl = variant.selectedOptions[0]?.dataset.image;
      if (image && imageUrl) {
        image.removeAttribute('srcset');
        image.src = imageUrl;
        image.alt = variant.selectedOptions[0]?.dataset.variantTitle || '';
      }
      if (sku) sku.textContent = variant.selectedOptions[0]?.dataset.sku || '';
      status.textContent = '';
    });
    if (checkout) checkout.hidden = false;
    const add = async (direct) => {
      if (busy || !form.reportValidity()) return;
      const buttons = [...form.querySelectorAll('button[type="submit"], [data-direct-checkout]')];
      const originals = buttons.map(button => ({button,disabled:button.disabled}));
      if (originals.every(item => item.disabled)) return;
      busy = true;
      buttons.forEach(button => button.disabled = true);
      if (quantity) updateQuantity();
      status.textContent = config.adding;
      try {
        const body = new FormData(form);
        const response = await fetch(root + 'cart/add.js', {method:'POST',body,headers:{Accept:'application/json'}});
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || config.error);
        status.textContent = config.added;
        const viewCart = form.querySelector('.rhsb-view-cart');
        if (viewCart) viewCart.hidden = false;
        if (direct) {
          window.location.assign(root + 'cart');
          return;
        }
        try {
          const cartResponse = await fetch(root + 'cart.js', {headers:{Accept:'application/json'}});
          if (cartResponse.ok) {
            const cart = await cartResponse.json();
            document.querySelectorAll('.cart-link span').forEach(count => count.textContent = cart.item_count);
            document.dispatchEvent(new CustomEvent('rhsb:cart-updated', {detail:cart}));
          }
        } catch (_) { /* The item was added successfully; a cart badge refresh must not report an add failure. */ }
      } catch (error) {
        status.textContent = error.message || config.error;
      } finally {
        busy = false;
        originals.forEach(({button,disabled}) => button.disabled = disabled);
        if (quantity) updateQuantity();
      }
    };
    form.addEventListener('submit', event => {event.preventDefault(); add(false);});
    checkout?.addEventListener('click', () => add(true));
  });
})();